<template>
    <div class="warpper padding-sm">
        <div class="classifys flex align-center">
            <router-link class="classify active" to="/organization/fee/invoice">开票管理</router-link>
            <router-link class="classify" to="/organization/fee/finvoice">分支机构开票管理</router-link>
        </div>
        <div class="flex align-center justify-between margin-bottom-sm">
            <div class="page-title line-height">开票记录</div>
            <div class="page-operate yellow" @click="exportList">批量导出</div>
        </div>
        <div class="flex align-center">
            <el-date-picker
                    v-model="time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
            </el-date-picker>
            <el-input class="w-50 margin-lr-sm" v-model="search_content" placeholder="请输入姓名、手机号"></el-input>
            <div class="page-operate margin-left-xs" @click="search">搜索</div>
        </div>
        <div class="ship-list margin-top">
            <el-table
                    v-loading="loading"
                    :data="lists"
                    header-row-class-name="table-header"
                    border
                    style="width: 100%; border-radius: 10px">
                <el-table-column label="姓名" prop="name">
                    <template slot-scope="scope">
                        <div class="table-name"> {{scope.row.name}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="tel" label="手机号">
                    <template slot-scope="scope">
                        <div class="table-name">
                            {{scope.row.tel}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="invoice_name" label="开票名称">
                    <template slot-scope="scope">
                        <div class="table-name">
                            {{scope.row.invoice_name}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="invoice_identifier" label="纳税人识别码">
                    <template slot-scope="scope">
                        <div class="table-name">
                            {{scope.row.invoice_identifier}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="fapiao_img" label="发票">
                    <template slot-scope="scope">
                        <div class="table-name" v-if="scope.row.fapiao_img">
                            <el-link :href="scope.row.fapiao_img" target="_blank">查看</el-link>
                        </div>
                        <div class="table-name" v-else>
                            --
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="address" label="收件地址">
                    <template slot-scope="scope">
                        <div class="table-name">
                            {{scope.row.address}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="amount" label="金额（元）">
                    <template slot-scope="scope">
                        <div class="table-name">
                            {{scope.row.amount}}元
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="add_time" label="时间">
                    <template slot-scope="scope">
                        <div class="table-name">
                            {{scope.row.add_time}}
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination
                class="page-all margin-top"
                background
                @current-change="init"
                :current-page.sync="page"
                :page-size="limit"
                layout="prev, pager, next, jumper"
                :total="total">
        </el-pagination>
    </div>
</template>

<script>
    import {getInvoiceList} from '@/api/organiz'
    import {zhDate} from "@/utils/utils";
    import {baseURL} from "@/config/index";

    export default {
        name: "invoice",
        data() {
            return {
                search_content:'',
                time: [],
                lists: [],
                page: 1,
                limit: 13,
                total: 0,
                loading: false,
            }
        },
        computed: {
            user() {
                return this.$store.state.user
            }
        },
        created() {
            this.$emit('setIndex', [4, 1], '开票记录')
            this.init()
        },
        components: {},
        methods: {
            //  页面加载时请求
            async init() {
                this.loading = true
                let _data = await getInvoiceList(this.search_content,this.time.length !==0  ? this.time[0] : '', this.time.length !==0  ? this.time[1] : '', this.page, this.limit)
                this.loading = false
                if (_data.status === 200) {
                    _data.data.map(item => {
                        item.add_time = zhDate(item.add_time * 1000)
                    })
                    this.lists = _data.data
                    this.total = _data.count
                } else {
                    this.lists = [];
                    this.total = 0;
                }
            },
            search(){
                this.page = 1
                this.init()
            },
            exportList(){
                window.open(baseURL + 'Admin/User/export_invoice_list?mid='+ this.user.mid
                    +'&sign='+ this.user.sign
                    + '&start_time=' + (this.time.length !==0  ? this.time[0] : '')
                    + '&end_time=' + (this.time.length !==0  ? this.time[1] : ''))
            }
        },
        filters: {},
        watch: {},
    }
</script>

<style scoped lang="scss">
    .warpper {
        background: #fff;
        border-radius: 10px;
        .classifys {
            margin-bottom: 20px;

            .classify {
                width: 120px;
                height: 40px;
                line-height: 40px;
                text-align: center;
                border: 1px solid #ffb400;
                color: #ffb400;
                border-radius: 0 6px 6px 0;

                &.active {
                    background: #ffb400;
                    color: #FFFFFF;
                    border-radius: 6px 0 0 6px;
                }
            }
        }
        .table-name {
            font-size: 14px;
            color: #333333;
            text-align: center;
            &.gray {
                color: #999999;
            }
        }
        .table-operate {
            width: 60px;
            height: 30px;
            padding: 0;
            border-radius: 15px;
            background-color: #0a2240;
            border: solid 1px #0a2240;
            font-size: 14px;
            color: #ffffff;
            &.line {
                background-color: #ffffff;
                color: #0a2240;
            }
            &:disabled {
                background-color: #ffffff;
                border: solid 1px #dae0e6;
                color: #bcc6cf;
            }
        }
    }
</style>